import type Vue from 'vue'
import { isClosestNode } from 'www/utils'
import type {
  getLpuItemInterface,
  getDoctorsItemInterface,
  getServicesItemInterface,
  getDoctorsLpuItemInterface,
} from 'www/modules/Schedule/models/item'
import type { ScheduleRequest, ScheduleRenderProps } from 'www/modules/Schedule/models/other'

export type ScheduleItem = (
  | ReturnType<typeof getLpuItemInterface>
  | ReturnType<typeof getDoctorsItemInterface>
  | ReturnType<typeof getServicesItemInterface>
  | ReturnType<typeof getDoctorsLpuItemInterface>
) & { coverNode: HTMLElement; scheduleNode: HTMLElement; scheduleNodeHTML: string }

export type ScheduleModuleData = {
  items: Map<HTMLElement, ScheduleItem>
  storage: Record<string, unknown>
  instances: Map<HTMLElement, InstanceType<typeof Vue>>
  request: ScheduleRequest
  render: Map<HTMLElement, ScheduleRenderProps>
}

/**
 * @description
 * Производит поиск нужного data.item элемента на страницы, у которого родителем является узел с атрибутом 'data-schedule-item' и возвращает массив данных
 *
 * @param {object} opts -
 * @returns {[HTMLElement | null, ScheduleItem | null]} - массив, первый элемент которого узел для монтирования календаря, а второй элемент - один из интерфейсов 'getLpuItemInterface'
 * | 'getDoctorsItemInterface'
 * | 'getServicesItemInterface'
 * | 'getDoctorsLpuItemInterface'
 * а также данные об узлах 'getNodesItemInterface'
 */

export const getItemDataWithParent = ({
  data,
  target,
}: {
  data: ScheduleModuleData
  target: HTMLElement
}): [HTMLElement | null, ScheduleItem | null] => (
  [...data.items].find(([, { coverNode }]) => isClosestNode(target, coverNode)) || [null, null]
)
